import * as React from 'react';
export const DEFAULT_HOTEL_BASKET = {
    selectedRooms: [],
    selectedFlight: undefined,
    estabId: '',
    tripStateId: '',
    waitingForRooms: true,
    waitingForFlights: true,
    hotelCheckInDate: '',
    availabilityErrors: [],
    unavailableRoomIds: [],
    automaticRoomSelection: false,
};
export const HotelBasketContext = React.createContext({
    hotelBasket: DEFAULT_HOTEL_BASKET,
    dispatch: () => null,
});
export function useHotelBasketContext() {
    const context = React.useContext(HotelBasketContext);
    return React.useMemo(() => context, [context]);
}
